// GET请求
import Axios from 'plugins/axios.js';

export function getProblemList(param) {
  return Axios({
    url:'/v1/contest/problem',
    method:'get',
    params:param
  });
};